const auditTransactionTypesAllReducer = (state = [{code: "all", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDSHARK_TRANSACTION_LOG_TYPES_ALL':
      return action.results;
    default:
      break;
  }
  return state;
}

export default auditTransactionTypesAllReducer;